// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"276412cb","408":"82bb56f7"}[chunkId] + ".chunk.js";
};